import {
  Directive,
  Output,
  ElementRef,
  EventEmitter,
  HostListener,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[fileSelect]',
})
export class FileSelectDirective {
  @Output() fileSelect: EventEmitter<File> = new EventEmitter();

  constructor(elementRefPrivate: ElementRef, renderer: Renderer2) {}

  @HostListener('change', ['$event'])
  onChange(event: Event): void {
    if (event.target instanceof HTMLInputElement) {
      const fileInputEl: HTMLInputElement = event.target as HTMLInputElement;
      const files: FileList = fileInputEl.files;
      if (files.length) {
        const value: File = files[0];
        this.fileSelect.emit(value);
      }
    }
  }
}
